import { render, staticRenderFns } from "./NavbarLanguage.vue?vue&type=template&id=29c38db8"
import script from "./NavbarLanguage.vue?vue&type=script&lang=js"
export * from "./NavbarLanguage.vue?vue&type=script&lang=js"
import style0 from "./NavbarLanguage.vue?vue&type=style&index=0&id=29c38db8&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29c38db8')) {
      api.createRecord('29c38db8', component.options)
    } else {
      api.reload('29c38db8', component.options)
    }
    module.hot.accept("./NavbarLanguage.vue?vue&type=template&id=29c38db8", function () {
      api.rerender('29c38db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NavbarLanguage.vue"
export default component.exports